export const getFilesSize = async (url: string) => {
  try {
    const response = await fetch(url);
    const contentLength = parseInt(response.headers.get('content-length') || '0', 10);
    if (contentLength) {
      const sizeInBytes = contentLength;
      const sizeInKilobytes = sizeInBytes / 1024;
      const sizeInMegabytes = sizeInKilobytes / 1024;
      return {
        bytes: sizeInBytes,
        kilobytes: sizeInKilobytes.toFixed(2),
        megabytes: sizeInMegabytes.toFixed(2)
      };
    }
  } catch (error) {
    console.error(error)
    
  }
}